/* eslint-disable react/no-deprecated */
import TablePaginationMui from '@material-ui/core/TablePagination';
import TableFooterMui from '@material-ui/core/TableFooter';
import { useEffect } from 'react';
import { mainColor, UNIT } from '../../constants/theme';
import Paper from '../Paper';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { initPage, updatePage, updateRowPerPage } from 'src/actions';


export type TableFooterProps = {
    lengthOption: number,
    rowsPerPageOptions?: number[],
    updateRowPerPage?: any
}

export default function TableFooter({ lengthOption, rowsPerPageOptions }: TableFooterProps) {
    const { rowsPerPage, numPage } = useAppSelector(state => state.page);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(initPage(rowsPerPage));
    }, [dispatch, rowsPerPage])

    return (
        <div className='row noselect'>
            <div className='col-12 pt-3 d-flex justify-content-center'>
                <Paper
                    className='width-md-25%'
                    style={{
                        backgroundColor: mainColor.colorWhiteLight
                    }}
                >
                    <TableFooterMui
                        style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <TablePaginationMui
                            style={{ paddingRight: UNIT * 1.375 }}
                            rowsPerPageOptions={rowsPerPageOptions}
                            count={lengthOption}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage='Lignes par page'
                            page={numPage}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page'
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page'
                            }}
                            onPageChange={(event, numPage) => dispatch(updatePage(numPage))}
                            onRowsPerPageChange={event => dispatch(updateRowPerPage(event.target.value))}
                        />
                    </TableFooterMui>
                </Paper>
            </div>
        </div>
    );
}